import React, {useCallback, useState} from 'react';
import {LetterSpacing} from '~/common/fabric/CreateDesign/components/CardEditor/actions/LetterSpacing/LetterSpacing';
import {LineHeight} from '~/common/fabric/CreateDesign/components/CardEditor/actions/LineHeight/LineHeight';
import './SpacingHeight.sass';
import {Typography} from '~library/atoms/Typography';

export const SpacingHeight = () => {
  const tabs = {
    LETTER_SPACING: {
      label: 'Letter Spacing',
      key: 'LETTER_SPACING',
      component: <LetterSpacing />,
    },
    LINE_HEIGHT: {
      label: 'Line Height',
      key: 'LINE_HEIGHT',
      component: <LineHeight />,
    },
  };

  const [activeTab, setActiveTab] = useState(tabs.LETTER_SPACING.key);

  const onTabClick = useCallback((tab) => () => setActiveTab(tab), []);

  return (
    <div className="spacing_height">
      <div className="spacing_height__tabs">
        {Object.keys(tabs).map((key) => (
          <div
            key={tabs[key].key}
            tabIndex={-1}
            role="button"
            onKeyUp={null}
            onClick={onTabClick(tabs[key].key)}
            className="spacing_height__tabs__tab"
          >
            <Typography
              variant="label2"
              color="pebble"
              classNames={`spacing_height__tabs__tab__label mobile-editor__tab__label ${
                tabs[key].key === activeTab ? 'spacing_height__tabs__tab__label--active' : ''
              }`}
            >
              {tabs[key].label}
            </Typography>
          </div>
        ))}
      </div>
      <div className="spacing_height__content">{tabs[activeTab].component}</div>
    </div>
  );
};
